import { connect } from "react-redux";
import { Form } from "formik";
import moment from "moment";
import React from "react";
import { withRouter } from "react-router-dom";
import * as yup from "yup";

import { sharedRequests } from "@/api/(requests)/shared";

import Button from "../../../UI/Button";
import { CustomForm } from "../../../../component-library/CustomForm";
import { dobValidationSchema } from "../../../../containers/Dashboard/Providers/schema/newPatientValidation";
import FormikInput from "../../../UI/FormikInput";
import FormikInputFormat from "../../../UI/formikMobileInput";
import images from "../../../../utils/images";
import { showAlertWithAction } from "../../../../redux/actions/alerts";

const AccountLookup = (props) => {
  const { setSharedWorkflowData, sharedWorkflowData } = props;

  const submitHandler = async (formData, actions) => {
    try {
      const data = {
        dob: moment(formData.dob, "MMDDYYYY").format("MM/DD/YYYY"),
        email: formData.email,
        workflow_instance_entity_id: sharedWorkflowData.workflow_instance.entity_id,
        workflow_instance_sort_key: sharedWorkflowData.workflow_instance.sort_key,
      };
      const response = await sharedRequests.account_lookup({ data });

      setSharedWorkflowData({
        ...sharedWorkflowData,
        workflow_instance: response.workflow_instance,
      });
    } catch (e) {
      console.log(e);
      props.showAlertWithAction("Error looking up account.");
    }
  };

  const renderForm = (formikProps) => {
    const formikInputProps = {
      errors: formikProps.errors,
      inputClasses: "Input--sm",
      touched: formikProps.touched,
    };

    return (
      <Form>
        <div className="mx-auto px-0 mb-3">
          <div className="px-0 row pb-5">
            <div className="col-12">
              <FormikInputFormat
                {...formikInputProps}
                formEl={{
                  elementConfig: {
                    label: "Date of Birth",
                    placeholder: "MM/DD/YYYY",
                    type: "text",
                  },
                  elementType: "input",
                  name: "dob",
                }}
                onChange={async (val) => {
                  await formikProps.setFieldValue("dob", val.value);
                  formikProps.setFieldTouched("dob");
                }}
                value={formikProps && formikProps.values["dob"]}
              />
            </div>

            <div className="col-12">
              <FormikInput
                {...formikInputProps}
                formEl={{
                  elementConfig: {
                    label: "Email",
                    placeholder: "Enter Email",
                    type: "email",
                  },
                  elementType: "input",
                  name: "email",
                }}
              />
            </div>

            <div className="col-12">
              <FormikInput
                {...formikInputProps}
                formEl={{
                  elementConfig: {
                    label: "Confirm Email",
                    placeholder: "Re-enter Email",
                    type: "email",
                  },
                  elementType: "input",
                  name: "email_validation",
                }}
              />
            </div>
          </div>
        </div>

        <div className="d-flex justify-content-between">
          <Button
            className="Btn Btn--otl-gry Btn--sm-2 workflow-btn"
            onClick={props.backHandler}
            type="button"
          >
            Back
          </Button>
          <Button className="Btn Btn--pri Btn--sm-2 workflow-btn" type="submit">
            Confirm
          </Button>
        </div>
      </Form>
    );
  };

  return (
    <div className="p-lg-5 p-3">
      <div className="fs-22 txt-pri mb-5 text-center tw:font-bold">
        Let's check your eligibility
      </div>
      <div className="text-center my-5">
        <img
          alt="Eligibility Check"
          src={images("./common/workflow/eligibility-check-active.png")}
        />
      </div>
      <div className="workflow-container-sm">
        {sharedWorkflowData && sharedWorkflowData.workflow_instance && (
          <>
            <CustomForm
              initialValues={{
                dob: "",
                email: "",
                email_validation: "",
              }}
              onSubmit={submitHandler}
              render={renderForm}
              validationSchema={accountLookUpValidation}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default connect(null, { showAlertWithAction })(withRouter(AccountLookup));

const accountLookUpValidation = yup.object().shape({
  dob: dobValidationSchema.required("Date of birth is required"),
  email: yup.string().email("Enter a valid email address").required("Email is required"),
  email_validation: yup
    .string()
    .email("Enter a valid email address")
    .required("Email is required")
    .test("email-match", "Email address does not match, please check spelling", function (value) {
      if (!value) {
        return false;
      }

      return this.parent.email === value;
    }),
});
